module.exports = new Promise(resolve => {
            const urlHost = window.location.host;
            const isProd = urlHost === 'xlr8.arrivelogistics.com';
            const isStg = urlHost === 'xlr8-stg.arrivelogistics.com';
            const isTest = urlHost === 'xlr8-test.arrivelogistics.com';

            const localSource = "http://127.0.0.1:3006";
            const devSource = "https://white-bush-039ab0e10.1.azurestaticapps.net";
            const testSource = "https://calm-sky-0d442b710.2.azurestaticapps.net";
            const stgSource = "https://happy-flower-038fc1510.2.azurestaticapps.net";
            const prodSource = "https://wonderful-stone-00d9bea10.1.azurestaticapps.net";

            const localManifestSource = localSource + "/manifest.json";
            const devManifestSource = devSource + "/manifest.json";
            const testManifestSource = testSource + "/manifest.json";
            const stgManifestSource = stgSource + "/manifest.json";
            const prodManifestSource = prodSource + "/manifest.json";

            let sourceToUse = devSource;
            let manifestSourceToUse = devManifestSource;

            if (isProd) {
                manifestSourceToUse = prodManifestSource;
                sourceToUse = prodSource;
            } else if (isStg) {
                manifestSourceToUse = stgManifestSource;
                sourceToUse = stgSource;
            } else if (isTest) {
                manifestSourceToUse = testManifestSource;
                sourceToUse = testSource;
            }

            // uncomment if you want to use local env
            // manifestSourceToUse = localManifestSource;
            // sourceToUse = localSource;
            fetch(manifestSourceToUse, { cache: 'no-store' })
                .then(res => res.json())
                .then(manifest => {

                    console.log('Manifest fetched [FNOW]:', manifest);

                    const script = document.createElement('script')

                    script.src = sourceToUse + "/remoteEntry." + manifest.remoteEntryHash + ".js";

                    script.onload = () => {
                        const proxy = {
                            get: (request) => window.FederatedNow.get(request),
                            init: (arg) => {
                                try {
                                    return window.FederatedNow.init(arg)
                                } catch(e) {
                                    console.log('FederatedNow container already initialized')
                                }
                            }
                        }
                        resolve(proxy)
                    }

                    script.onerror = () => {
                        console.log('Error loading FederatedNow script, providing fallback');
                        const fallbackProxy = {
                            get: () => Promise.resolve(() => null),
                            init: () => {
                                console.log('FederatedNow fallback - module not available')
                                return Promise.resolve()
                            }
                        }
                        resolve(fallbackProxy)
                    }

                    document.head.appendChild(script);
                })
                .catch((error) => {
                  console.log('Error fetching FederatedNow manifest:', error);
                  // Always resolve with fallback to prevent app crash
                  const fallbackProxy = {
                    get: () => Promise.resolve(() => null),
                    init: () => {
                        console.log('FederatedNow fallback - manifest fetch failed')
                        return Promise.resolve()
                    }
                  }
                  resolve(fallbackProxy)
                })

            });